<script setup lang="ts">
import type {PropType} from 'vue'
import type {BasketItemInterface} from "~/interfaces/BasketItemInterface";
import InputCount from "~/components/UI/inputs/InputCount.vue";
import IconDef from "~/components/UI/IconDef.vue";

defineProps({
    product: {
        type: Object as PropType<BasketItemInterface>,
        required: true
    }
});

defineEmits(['delete']);

</script>

<template>
    <div class="basket__item basket-item">
        <div class="basket-item__body">
            <div class="basket-item__photo">
                <NuxtLink :to="`/product/${product.id}`"><img :src="product.img" :alt="product.name" v-if="product.img">
                </NuxtLink>
            </div>
        </div>
        <div class="basket-item__right">
            <div class="basket-item__info">
                <div class="basket-item__name">
                    <NuxtLink :to="`/product/${product.id}`">{{ product.name }}</NuxtLink>
                </div>
                <div class="basket-item__attr" v-if="product.size">Размер: <span>{{ product.size }}</span></div>
                <div class="basket-item__attr" v-for="param in product.params">
                    {{ param.name }}: <span>{{ param.value }}</span>
                </div>
                <div class="basket-item__icons">
                    <!--                    <div class="basket-item__favorite">-->
                    <!--                        <IconDef :name="product.favorite ? 'favorite' : 'infavorite' "></IconDef>-->
                    <!--                    </div>-->
                    <div class="basket-item__remove" @click="$emit('delete')">
                        <IconDef name="remove"></IconDef>
                    </div>
                </div>
            </div>
            <div class="basket-item__count">
                <div class="input-count">
                    <InputCount
                            :min="1"
                            :max="product.amount"
                            type="text"
                            v-model="product.count"
                    />
                </div>
            </div>
            <div class="basket-item__prices">
                <div class="basket-item__price">{{ product.price * product.count }} ₽</div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>